import { render, staticRenderFns } from "./GenerateNotices.vue?vue&type=template&id=48bd5c7a&scoped=true&"
import script from "./GenerateNotices.vue?vue&type=script&lang=js&"
export * from "./GenerateNotices.vue?vue&type=script&lang=js&"
import style0 from "./GenerateNotices.vue?vue&type=style&index=0&id=48bd5c7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bd5c7a",
  null
  
)

export default component.exports